import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import {
  buildMapData,
  dataAgeInDays,
  locationCount,
  parseSpecialties,
  secondaryLocations,
  splitTeam,
} from '../../_shared/domain/company-detail.rules';

const selectInstitutionalDetail = (state: RootState) => state.institutionalDetail;

export const selectCompany = (state: RootState) => selectInstitutionalDetail(state).company;
export const selectLoadStatus = (state: RootState) => selectInstitutionalDetail(state).loadStatus;
export const selectTeam = (state: RootState) => selectInstitutionalDetail(state).team;
export const selectTeamStatus = (state: RootState) => selectInstitutionalDetail(state).teamStatus;
export const selectEnrich = (state: RootState) => selectInstitutionalDetail(state).enrich;

// ── Derived, memoised on the company / team reference (pure domain rules) ──
export const selectSecondaryLocations = createSelector(selectCompany, secondaryLocations);
export const selectSpecialties = createSelector(selectCompany, parseSpecialties);
export const selectMapData = createSelector(selectCompany, buildMapData);
export const selectLocationCount = createSelector(selectCompany, locationCount);
/** Days since the data was last refreshed, measured when the company record changes. */
export const selectDataAgeDays = createSelector(selectCompany, (company) =>
  dataAgeInDays(company, Date.now()),
);
export const selectTeamSplit = createSelector(selectTeam, splitTeam);
